module.exports = __webpack_public_path__ + "static/img/manual-29.8a5d24f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-29.png
// module id = 1nhH
// module chunks = 4